import React from 'react';
import { RegularButton, Typography } from 'fronton-react';
import { ArrowUpRightIcon, DownloadSimpleIcon } from '@fronton/icons-react';
import { documentItem, documentItemContent, documentItemIcon } from './styles';

type Props = {
  title: string;
  description: string;
  type: string;
  href?: string;
  dataQa?: string;
  onClick?: () => void;
};

export const DocumentItem = ({ title, description, href, type, dataQa, onClick }: Props) => {
  const isDownloadable = type === 'manual';

  return (
    <RegularButton
      target="_blank"
      rel="noopener noreferrer"
      href={href}
      onClick={onClick}
      className={documentItem}
      variant="pseudo"
      wide={true}
      data-qa={dataQa}
    >
      <span className={documentItemIcon}>
        {isDownloadable ? (
          <DownloadSimpleIcon type="outline" size="l" color="text-primary" />
        ) : (
          <ArrowUpRightIcon type="outline" size="l" color="text-primary" />
        )}
      </span>

      <span className={documentItemContent}>
        <Typography data-qa={`${dataQa}-title`} size="body_short" variant="s">
          {title}
        </Typography>
        <Typography data-qa={`${dataQa}-description`} size="caption" variant="minor" color="text-secondary">
          {description}
        </Typography>
      </span>
    </RegularButton>
  );
};
